<template>
  <div>

    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="content-container">
            <SportipsButton toPage="Home" chevronLeft mobile-full-width>Retour à
              l'accueil</SportipsButton>

            <!-- Si c'est une inscription en groupe, formulaire des champs par défaut -->
            <InscriptionGroupe v-if="bookingStore.is_groupe"></InscriptionGroupe>
            <!-- S'il y a des inscriptions d'équipes, on affiche les formulaires de gestion d'équipes  -->
            <GestionEquipes v-if="mainStore.module.need_gestion_equipe && mainStore.bookingSystem"></GestionEquipes>

            <div class="text-h6 font-weight-bold my-3"><v-icon icon="mdi-file-document-edit-outline" color="primary"
                size="xs-small"></v-icon> <span v-if="mainStore.billetterie_mode">Effectuer une commande</span><span
                v-else>Inscriptions</span></div>

            <!-- Boucle sur les inscriptions de la réservation -->
            <div class=" my-3 " v-for="(inscription, index_inscription) in bookingStore.inscriptions"
              :key="index_inscription + '_' + bookingStore.inscriptions.length">
              <InscriptionItem :item="inscription"
                :open_first_tab="index_inscription == bookingStore.inscriptions.length - 1" :index="index_inscription"
                @deleteItem="deleteInscription(index_inscription)"></InscriptionItem>
            </div>




            <!-- Si ce n'est pas une inscription en billetterie, on affiche le bouton d'ajout de participants -->
            <ButtonAddInscription v-if="!mainStore.billetterie_mode"></ButtonAddInscription>
            <v-divider></v-divider>
            <!-- Handler donation empreinte carbon VVX25 -->
            <FormulaireEmpreinteCarbone
              v-if="mainStore.module.has_donation_empreinte_carbone && bookingStore.has_inscriptions">
            </FormulaireEmpreinteCarbone>

            <!-- Affiche les checkboxes de prises de connaissances -->
            <v-row v-if="bookingStore.show_reglement_checkboxes">
              <v-col>
                <v-checkbox v-if="!has_remove_checkboxes_fin_inscription" class="checkbox_connaissance mb-1"
                  color="primary-dark" hide-details v-model="accept_reglement">
                  <template v-slot:label v-if="!mainStore.billetterie_mode">
                    <p>J'ai pris connaissance du <a v-if="mainStore.module.url_reglement" target="_blank"
                        :href="mainStore.module.url_reglement">règlement</a><span v-else>règlement</span>, en accepte
                      les termes sans réserve.</p>
                  </template>
                  <template v-slot:label v-else>
                    <p>J'ai pris connaissance des <a v-if="mainStore.module.url_reglement" target="_blank"
                        :href="mainStore.module.url_reglement">CGV</a><span v-else>CGV</span>, en accepte les termes
                      sans réserve.</p>
                  </template>
                </v-checkbox>
                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                  v-model="accept_donnees">
                  <template v-slot:label>
                    <p>J'ai pris connaissance des <a href="https://sportips.fr/vie-privee.php"
                        target="_blank">informations relatives au traitement de mes données</a>, dont j'autorise le
                      recueil par Sportips.</p>
                  </template>
                </v-checkbox>
                <v-checkbox v-if="!has_remove_checkboxes_fin_inscription" class="checkbox_connaissance mb-1"
                  color="primary-dark" hide-details v-model="accept_newsletter">
                  <template v-slot:label>
                    <p>J'accepte de recevoir les news Courses de la part de Sportips.</p>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>

            <PopupErrorFFR class="my-3"
              v-if="mainStore.module.is_longe_cote_ffrp && validation_ffr && validation_ffr.details"
              :validation="validation_ffr">
            </PopupErrorFFR>



            <!-- Bouton de finalisation de la commande -->
            <div class="d-flex justify-center mb-1 mx-1" v-if="bookingStore.show_reglement_checkboxes">

              <v-alert v-if="bookingStore.has_some_inscriptions_opened" border="start" border-color="red"
                class="bg-spo-blue-grey">
                Vous devez compléter l'inscription ouverte afin d'accéder au paiement de la commande.
              </v-alert>
              <v-alert v-else-if="!accept_donnees || !accept_reglement" border="start" border-color="red"
                class="bg-spo-blue-grey">
                Vous devez accepter le règlement de l'épreuve et autoriser Sportips à traiter vos données afin d'accéder
                au paiement
                de la commande.
              </v-alert>
              <v-alert v-else-if="!mainStore.bookingSystem.equipes.equipes_have_valid_names" border="start"
                border-color="red" class="bg-spo-blue-grey">
                Vous devez donner un nom valide à vos équipes sur les courses en duo/équipe.
              </v-alert>
              <v-alert v-else-if="!mainStore.bookingSystem.equipes.equipes_are_full" border="start" border-color="red"
                class="bg-spo-blue-grey">
                Le nombre de coureur requis n'est pas atteint pour une de vos équipes.
              </v-alert>
              <v-alert v-else-if="!mainStore.bookingSystem.equipes.equipes_have_fields" border="start"
                border-color="red" class="bg-spo-blue-grey">
                Vous devez remplir tous les champs additionnels pour vos équipes.
              </v-alert>
              <v-alert v-else-if="!mainStore.bookingSystem.equipes.equipes_have_valid_sexes" border="start"
                border-color="red" class="bg-spo-blue-grey">
                Certaines de vos équipes doivent être mixtes pour cette course.
              </v-alert>


              <SportipsButton v-else-if="mainStore.module.is_longe_cote_ffrp" @click="check_equipes_ffr()"
                icon="mdi-arrow-right-bold" action-button mobile-full-width chevron>
                Accéder au paiement
              </SportipsButton>


              <SportipsButton v-else toPage="Cart" icon="mdi-credit-card" action-button mobile-full-width chevron>
                <span v-if="bookingStore.prix_total > 0">Accéder au paiement</span>
                <span v-else>Accéder à la dernière étape</span>
              </SportipsButton>






            </div>

          </div>
        </v-col>
        <v-col lg="3" cols="12">
          <ShoppingCart v-if="bookingStore" ref="shopping_cart">
          </ShoppingCart>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import InscriptionItem from "@/components/Inscription/InscriptionItem.vue";
import InscriptionGroupe from "@/components/Inscription/InscriptionGroupe.vue";
import GestionEquipes from "@/components/Inscription/GestionEquipes.vue";
import ShoppingCart from "@/components/App/Shopping_Cart/Shopping_Cart.vue";
import EquipeFFRValidator from "@/classes/Equipe/EquipeFFRValidator.class";
import PopupErrorFFR from "@/components/Inscription/PopupErrorFFR.vue";
import FormulaireEmpreinteCarbone from "@/components/Inscription/FormulaireEmpreinteCarbone.vue";
import ButtonAddInscription from "@/components/Inscription/ButtonAddInscription.vue";

export default {
  components: { InscriptionItem, InscriptionGroupe, ShoppingCart, GestionEquipes, PopupErrorFFR, FormulaireEmpreinteCarbone, ButtonAddInscription },
  data() {
    return {
      equipes: [],
      accept_reglement: false,
      accept_donnees: false,
      accept_newsletter: true,
      validation_ffr: {},
      loaded: false,
    };
  },
  watch: {
    "bookingStore.inscriptions": {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    has_remove_checkboxes_fin_inscription() {
      return this.mainStore.module.has_remove_checkboxes_fin_inscription;
    },
  },
  methods: {
    check_equipes_ffr() {
      let validator = new EquipeFFRValidator(this.bookingStore.$state, this.mainStore.bookingSystem.equipes.list, this.mainStore.module.courses.list, this.mainStore.module);
      this.validation_ffr = validator.validate();

      if (this.validation_ffr.status) {
        this.$router.push({ name: "Cart" });
      }
    },


    deleteInscription(index) {
      this.bookingStore.removeInscription(index);
      this.bookingStore.compute_cart();
    },

    check_access() {
      const is_loaded = this.mainStore.module.isLoaded;
      const view_as_admin = this.mainStore.view_as_admin;
      const inscription_as_admin = this.mainStore.inscription_as_admin;
      const is_inscription_open = this.mainStore.module.is_inscription_open;
      const module_complet = this.mainStore.module.is_complet;
      const is_inscription_groupe = this.mainStore.bookingSystem.groupe.is_inscription_groupe;
      const is_lien_groupe = this.mainStore.bookingSystem.groupe.is_lien_groupe;

      if (!is_loaded) {
        this.$router.push({ name: "Home" });
      }
      if (is_inscription_open && !module_complet) {
        return;
      }
      if (view_as_admin || inscription_as_admin) {
        return;
      }
      if (this.mainStore?.inscription_vip?.is_valid()) {
        return;
      }
      if (is_inscription_groupe && is_lien_groupe) {
        return;
      }
      this.$router.push({ name: "Home" });

    },


  },
  async created() {

    window.scrollTo(0, 0);

    this.check_access();
    this.mainStore.bookingSystem.init();
    await this.mainStore.champs_formulaire.fetch();
    if (this.has_remove_checkboxes_fin_inscription) {
      this.accept_reglement = true;
      this.accept_newsletter = false;
    }
    this.loaded = true;
  },
};
</script>

<style lang="scss">
.checkbox_connaissance .v-selection-control--inline {
  width: 100%;
  height: auto;
}

.checkbox_connaissance p {
  margin-bottom: 0;
}

.checkbox_connaissance .v-selection-control__wrapper {
  align-self: start !important;
}
</style>